import { useState, useEffect, useRef } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { FiChevronDown } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { handleError } from "src/Common/function";
import WOFormService from "src/Services/API/woform.service";

const AddFormModal = ({ shown, woId, onClose, onAssignForm, onCreateForm }) => {
  const [forms, setForms] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [search, setSearch] = useState("");
  const searchRef = useRef(null);

  useEffect(() => {
    if (!shown) return;
    setSelectedId(null);
    setDropdownOpen(false);
    setSearch("");

    WOFormService.getAllForms({ unassigned: true })
      .then((res) => {
        if (res.status === 200) {
          setForms(res.data || []);
        }
      })
      .catch((err) => handleError(err));
  }, [shown]);

  useEffect(() => {
    if (dropdownOpen && searchRef.current) {
      searchRef.current.focus();
    }
  }, [dropdownOpen]);

  if (!shown) return null;

  const selectedForm = forms.find((f) => f.id === selectedId);
  const filtered = forms.filter((f) =>
    f.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <OutsideClickHandler onOutsideClick={onClose}>
        <div className="w-[436px] bg-white rounded-[6px] flex flex-col">
          <div className="border-b-[1px] border-borderColor py-3 px-4 flex items-center justify-between">
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor">
              ADD FORM
            </p>
            <IoClose
              size={18}
              className="cursor-pointer text-titleColor"
              onClick={onClose}
            />
          </div>

          <div className="p-[18px]">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-4">
              Assign an existing form or create one.
            </p>

            <div className="w-full mb-4">
              <OutsideClickHandler onOutsideClick={() => setDropdownOpen(false)}>
                <div className="relative w-full">
                  <div
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus:border-blue-500 cursor-pointer"
                  >
                    <span className="font-OpenSansRegular text-[12px] truncate">
                      {selectedForm ? selectedForm.name : "Assign form"}
                    </span>
                    <FiChevronDown className="ml-2" size={15} />
                  </div>
                  {dropdownOpen && (
                    <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
                      <li className="px-3 py-2 sticky top-0 bg-white border-b">
                        <input
                          ref={searchRef}
                          type="text"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search..."
                          className="w-full text-[12px] font-OpenSansRegular outline-none"
                        />
                      </li>
                      {filtered.length === 0 && (
                        <li className="px-4 py-2 font-OpenSansRegular text-[12px] text-subTitleColor">
                          No forms available
                        </li>
                      )}
                      {filtered.map((form) => (
                        <li
                          key={form.id}
                          onClick={() => {
                            setSelectedId(form.id);
                            setDropdownOpen(false);
                            setSearch("");
                          }}
                          className="px-4 py-2 cursor-pointer hover:bg-gray-200 font-OpenSansRegular text-[12px]"
                        >
                          {form.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </OutsideClickHandler>
            </div>

            <div className="w-full mt-3">
              <div className="flex items-center justify-between gap-4">
                <div
                  onClick={onClose}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                >
                  CANCEL
                </div>
                <div
                  onClick={() => {
                    if (selectedId) onAssignForm(selectedId);
                  }}
                  className={`w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center ${selectedId
                    ? "bg-blueColor text-white cursor-pointer"
                    : "bg-gray-300 text-white cursor-not-allowed"
                    }`}
                >
                  ASSIGN
                </div>
              </div>
              <div className="flex items-center justify-center mt-3">
                <span
                  onClick={onCreateForm}
                  className="text-[14px] font-OpenSansMedium text-blueColor cursor-pointer underline"
                >
                  + CREATE FORM
                </span>
              </div>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default AddFormModal;
